const members = [
  {
    name: "Administration",
    list: [
      {
        name: "Thomas Sheridan",
        image: require("./../../../img/members/tom_sheridan.jpg"),
        position: "Team Captain",
        linkedin: "https://www.linkedin.com/in/thomasssheridanr/",
        major: "Aerospace Engineering",
        year: "BS 2026, MS 2027",
      },
      {
        name: "Ava Esselman",
        image: require("./../../../img/members/ava_esselman.jpg"),
        position: "External Vice President",
        linkedin: "https://www.linkedin.com/in/avae",
        major: "Aerospace Engineering",
        year: "BS 2027, MS 2028",
      },
      {
        name: "Gavin Verral",
        image: require("./../../../img/members/gavin_verral.jpg"),
        position: "Internal Vice President",
        linkedin: "https://www.linkedin.com/in/gverral/",
        major: "Aerospace Engineering",
        year: "2027",
      },
    ],
  },
  {
    name: "Hi-Lift",
    list: [
      {
        name: "Diego Prado",
        image: require("./../../../img/members/diego_prado.jpg"),
        position: "Hi-Lift Chief Engineer",
        linkedin: "https://www.linkedin.com/in/-diegoprado",
        major: "Aerospace Engineering",
        year: "2027",
      },
      {
        name: "Zayden Boonstra",
        //image: require("./../../../img/members/zayden_boonstra.jpeg"),
        position: "Hi-Lift Mechanical Systems Director",
        linkedin: "https://www.linkedin.com/in/zayden-boonstra-1243b0247/",
        major: "Mechanical Engineering",
        year: "2027",
      },
      {
        name: "Ella Casab",
        image: require("./../../../img/members/ella_casab.jpg"),
        position: "Hi-Lift Aerodynamics Lead",
        linkedin: "https://www.linkedin.com/in/ella-casab-1369483a4/",
        major: "Aerospace Engineering",
        year: "2029",
      },
      {
        name: "Sahil Chaudhri",
        //image: require("./../../../img/members/placeholder.jpg"),
        position: "Hi-Lift Propulsion Lead",
        linkedin: "https://www.linkedin.com/in/sahil-chaudhri",
        major: "Aerospace Engineering",
        year: "2028",
      },
      {
        name: "Kelly Burke",
        image: require("./../../../img/members/kelly_burke.jpg"),
        position: "Hi-Lift Manufacturing Lead",
        linkedin: "https://www.linkedin.com/in/kelburke819",
        major: "Aerospace Engineering",
        year: "2029",
      },
      {
        name: "Aayush Singla",
        //image: require("./../../../img/members/placeholder.jpg"),
        position: "Hi-Lift Fuselage and Payload Lead",
        linkedin: "https://www.linkedin.com/in/aayush--singla",
        major: "Mechanical Engineering",
        year: "2029",
      },
      {
        name: "Thomas Zhao",
        image: require("./../../../img/members/thomas_zhao.jpg"),
        position: "Hi-Lift Wing and Tail Lead",
        linkedin: "https://www.linkedin.com/in/tz-zhao",
        major: "Aerospace Engineering",
        year: "2029",
      },
    ],
  },
  {
    name: "Autonomous",
    list: [
      {
        name: "Kenta Ferval-Shioya",
        image: require("./../../../img/members/kenta_ferval_shioya.jpg"),
        position: "Autonomous Chief Engineer",
        linkedin: "www.linkedin.com/in/kentafs",
        major: "Mechanical Engineering",
        year: "2027",
      },
      {
        name: "Nacho Uriel Adrada",
        //image: require("./../../../img/members/nacho_uriel.jpg"),
        position: "Autonomous Mechanical Systems Director",
        linkedin: "https://www.linkedin.com/in/ignacio-uriel-adrada-735448328/",
        major: "Aerospace Engineering",
        year: "2028",
      },
      {
        name: "Jackie Lin",
        //image: require("./../../../img/members/jackie_lin.jpg"),
        position: "Autonomous Systems Director",
        linkedin: "http://www.linkedin.com/in/jackielin-uofm",
        major: "Computer Science",
        year: "2027",
      },
      {
        name: "Tyler Kolchuk",
        image: require("./../../../img/members/tyler_kolchuk.jpg"),
        position: "Autonomous Aerodynamics Lead",
        linkedin: "www.linkedin.com/in/tyler-kolchuk-88977a382",
        major: "Aerospace Engineering",
        year: "2027",
      },
      {
        name: "Sree Baruri",
        //image: require("./../../../img/members/placeholder.jpg"),
        position: "Autonomous Propulsion Lead",
        linkedin: "www.linkedin.com/in/sreehithbaruri",
        major: "Aerospace Engineering",
        year: "2029",
      },
      {
        name: "Seraphina Ng",
        //image: require("./../../../img/members/placeholder.jpg"),
        position: "Autonomous Manufacturing Lead",
        linkedin: "https://www.linkedin.com/in/seraphinang",
        major: "Mechanical Engineering",
        year: "2028",
      },
      {
        name: "Amit Kamath",
        image: require("./../../../img/members/amit_kamath.jpg"),
        position: "Main Structures Lead",
        linkedin: "https://www.linkedin.com/in/amit-kamath90/",
        major: "Aerospace Engineering",
        year: "2029",
      },
      {
        name: "Jiazhen (Sophie) Miao",
        image: require("./../../../img/members/jiazhen_miao.jpg"),
        position: "Autonomous Payload and Mechanisms Lead",
        linkedin: "https://www.linkedin.com/in/jiazhen-miao/",
        major: "Mechanical Engineering",
        year: "2029",
      },
      {
        name: "Vishal Myneni",
        //image: require("./../../../img/members/placeholder.jpg"),
        position: "Autonomous Stability & Controls Lead",
        linkedin: "https://www.linkedin.com/in/vishal-myneni-a52bb8314/",
        major: "Aerospace Engineering",
        year: "2027",
      },
      {
        name: "Gareth Tatum",
        //image: require("./../../../img/members/placeholder.jpg"),
        position: "Autonomous Flight Systems & Computer Vision Lead",
        linkedin: "https://www.linkedin.com/in/gareth-tatum-2140422b0/",
        major: "Computer Engineering",
        year: "BS 2027, MS 2028",
      },
    ],
  },
  {
    name: "Advanced Class",
    list: [
      {
        name: "Joseph Wisniewski",
        //image: require("./../../../img/members/joseph_wisniewski.jpg"),
        position: "Advanced Class Chief Engineer",
        linkedin: "https://www.linkedin.com/in/joseph-wisniewski-4131132b4/",
        major: "Aerospace Engineering",
        year: "2027",
      },
      {
        name: "Soren Lieu Neumann",
        //image: require("./../../../img/members/soren_neumann.jpg"),
        position: "Advanced Class Systems Director",
        linkedin: "https://www.linkedin.com/in/soren-lieu-neumann-85696b325/",
        major: "Aerospace Engineering",
        year: "2028",
      },
      {
        name: "Ryan Landini",
        image: require("./../../../img/members/ryan_landini.jpg"),
        position: "Advanced Class Aerodynamics & Propulsion Director",
        linkedin: "https://www.linkedin.com/in/ryan-landini/",
        major: "Aerospace Engineering",
        year: "2027",
      },
      {
        name: "Shaylen Bhatt",
        image: require("./../../../img/members/shaylen_bhatt.jpg"),
        position: "Advanced Class Aerodynamics Lead",
        linkedin: "https://www.linkedin.com/in/shaylenbhatt",
        major: "Aerospace Engineering",
        year: "2029",
      },
      {
        name: "Ethan Dyksterhouse",
        image: require("./../../../img/members/ethan_dyksterhouse.jpg"),
        position: "Advanced Class GNC Lead",
        linkedin: "https://www.linkedin.com/in/ethan-dyksterhouse",
        major: "Aerospace Engineering",
        year: "2027",
      },
      {
        name: "Tate Machado",
        //image: require("./../../../img/members/placeholder.jpg"),
        position: "Advanced Class Propulsion Lead",
        linkedin: "www.linkedin.com/in/tate-machado",
        major: "Aerospace Engineering",
        year: "2027",
      },
      {
        name: "Jack Lassen",
        image: require("./../../../img/members/jack_lassen.jpg"),
        position: "Advanced Class Manufacturing Lead",
        linkedin: "https://www.linkedin.com/in/jack-lassen-aerospace",
        major: "Aerospace Engineering",
        year: "2029",
      },
      {
        name: "Aaryan Prabhu",
        //image: require("./../../../img/members/aaryan_prabhu.jpg"),
        position: "Advanced Class Primary Structures Lead",
        linkedin: "https://www.linkedin.com/in/aaryan-prabhu/",
        major: "Aerospace Engineering",
        minor: "Materials Science",
        year: "2028",
      },
      {
        name: "Vansh Baxi",
        image: require("./../../../img/members/vansh_baxi.jpg"),
        position: "Advanced Class Secondary Aircraft Structures Lead",
        linkedin: "https://www.linkedin.com/in/vanshbaxi",
        major: "Mechanical Engineering",
        year: "2028",
      },
      {
        name: "Brayden Czarnecki",
        image: require("./../../../img/members/brayden_czarnecki.jpg"),
        position: "Advanced Class Hardware Lead",
        linkedin: "https://www.linkedin.com/in/brayden-czarnecki",
        major: "Electrical Engineering",
        year: "2027",
      },
      {
        name: "Mina Zheng",
        image: require("./../../../img/members/mina_zheng.jpg"),
        position: "Advanced Class Software Lead",
        linkedin: "https://www.linkedin.com/in/mina-zheng-407599254/",
        major: "Data Science & Statistics",
        year: "2027",
      },
    ],
  },
  {
    name: "Chairs",
    list: [
      {
        name: "Diego Prado",
        image: require("./../../../img/members/diego_prado.jpg"),
        position: "Truck Chair",
        linkedin: "https://www.linkedin.com/in/-diegoprado",
        major: "Aerospace Engineering",
        year: "2027",
      },
      {
        name: "Katherine Rybkin",
        image: require("./../../../img/members/katherine_rybkin.jpg"),
        position: "SaFE Chair & Manufacturing Tech Fellow",
        linkedin: "https://www.linkedin.com/in/kirybkin",
        major: "MSE Mechanical Engineering",
        year: "2028",
      },
      {
        name: "Carly Grant",
        //image: require("./../../../img/members/placeholder.jpg"),
        position: "Business Chair",
        linkedin: "https://www.linkedin.com/in/carly-grant/",
        major: "Aerospace Engineering",
        year: "2027",
      },
      {
        name: "Benjamin Gardiner",
        image: require("./../../../img/members/ben_gardiner.jpg"),
        position: "Webmaster",
        linkedin: "https://www.linkedin.com/in/benjamin-gardiner-695a1033b/",
        major: "Electrical Engineering",
        minor: "Computer Science",
        year: "2028",
      },
      {
        name: "Jiazhen (Sophie) Miao",
        image: require("./../../../img/members/jiazhen_miao.jpg"),
        position: "Graphic Design Chair",
        linkedin: "https://www.linkedin.com/in/jiazhen-miao/",
        major: "Mechanical Engineering",
        year: "2029",
      },
      {
        name: "Maria Aviles",
        image: require("./../../../img/members/maria_aviles.jpg"),
        position: "Social Media Chair",
        linkedin: "https://www.linkedin.com/in/maria-aviles-4029293a5",
        major: "Business Administration",
        year: "2029",
      },
      {
        name: "Michael Chen",
        //image: require("./../../../img/members/michael_chen.jpg"),
        position: "Aerodynamics Tech Fellow",
        linkedin: "https://www.linkedin.com/in/michael-j-chen",
        major: "Aerospace Engineering",
        year: "2027",
      },
      {
        name: "Timothy Garland",
        image: require("./../../../img/members/tim_garland.jpg"),
        position: "Propulsion Tech Fellow",
        linkedin: "https://www.linkedin.com/in/timothy-garland",
        major: "Aerospace Engineering",
        year: "2027",
      },
      {
        name: "Jeffrey Hung",
        //image: require("./../../../img/members/jeffrey_hung.jpg"),
        position: "Hardware Tech Fellow",
        linkedin: "https://www.linkedin.com/in/jeffreyhung2",
        major: "Electrical Engineering",
        year: "2027",
      },
    ],
  },
];

export default members;
